"use strict";

exports.__esModule = true;
exports.TimeRangeKindSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _excluded = ["placeholder", "translator"];
var _class, _TimeRangeKindSelector;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var TimeRangeKindSelector = exports.TimeRangeKindSelector = (0, _Core.withTranslator)(_class = (_TimeRangeKindSelector = /*#__PURE__*/function (_Component) {
  function TimeRangeKindSelector() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(TimeRangeKindSelector, _Component);
  var _proto = TimeRangeKindSelector.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      placeholder = _this$props.placeholder,
      translator = _this$props.translator,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "TimeRangeKindSelector",
      className: _core.Classes.HTML_SELECT
    }, /*#__PURE__*/_react["default"].createElement("select", extra, /*#__PURE__*/_react["default"].createElement("option", null, placeholder || translator.translate("TimeRangeKindSelector.placeholder", "Select")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "singleDay"
    }, translator.translate("TimeRangeKindSelector.singleDay", "Single Day")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "multiDay"
    }, translator.translate("TimeRangeKindSelector.multiDay", "Multiple Days"))));
  };
  return TimeRangeKindSelector;
}(_react.Component), _TimeRangeKindSelector.defaultProps = {
  translator: undefined
}, _TimeRangeKindSelector)) || _class;